import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    qtdAdults: 2,
    qtdChilds: 0,
    checkinDate: '',
    checkoutDate: '',
    focusName: false
  },
  mutations: {
    updateQtdAdults (state, newQtd) {
      state.qtdAdults = newQtd
    },
    updateQtdChilds (state, newQtd) {
      state.qtdChilds = newQtd
    },
    updateCheckinDate (state, newDate) {
      state.checkinDate = newDate
    },
    updateCheckoutDate (state, newDate) {
      state.checkoutDate = newDate
    },
    focusField (state) {
      state.focusName = true
    }
  }
})
